module.exports = __webpack_public_path__ + "public/images/captcha-square.c09f522e114a5cf205cdcfc92a15c9e6.svg";